module.exports = __webpack_public_path__ + "static/media/OurCompany3-FR.c5c34f6b.png";